

import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../src/components/Widget/ThemeContext';

function Arrow() {
  const { assistBackgroundColor } = useContext(ThemeContext);

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.97995 13.3534L5.21662 8.59006C4.89329 8.26673 4.89329 7.73673 5.21662 7.41006L9.97995 2.64673L10.6866 3.3534L6.03995 8.00006L10.6866 12.6467L9.97995 13.3534Z" fill="#202023"/>
    </svg>
  );
}


Arrow.propTypes = {
  ready: PropTypes.bool
};

export default Arrow;
